export default __webpack_public_path__ + "static/media/eye.7b8bb7e0.svg";